/**
 * Utility function to perform an array search and return an entry from the array.
 *
 * This will _always_ either return an array entry or throw an error; contrast with
 * the built in <arr>.find() method that will simply return undefined if a matching
 * entry is not found.
 *
 * The use case of this is for instances where we should short circuit processing if
 * we fail to find an array entry; this saves us from having to manually check if the
 * result is undefined.
 *
 * It also makes TS aware that the result will be defined.
 */
export const findOrThrow = <T>(
  arr: Array<T>,
  predicate: (t: T) => boolean,
  opts?: {
    errorMsg?: string;
  },
): T => {
  const val = arr.find((i) => predicate(i));
  if (!val) {
    throw new Error(opts?.errorMsg ?? 'Failed to find item');
  }
  return val;
};
